import React from 'react';
import { Link } from 'react-router-dom';
import defaultBg from "../../assets/img/banner/about-banner.jpeg"; 

const BreadCrumb = ({ title, innerTitle, bgImage }) => {
    return (
        <>
            <style>
                {`
                    .responsive-breadcrumb {
                        background-size: cover;
                        background-position: center;
                        padding-top: 400px; /* Desktop Height */
                    }
                    
                    /* Mobile View Adjustments */
                    @media (max-width: 768px) {
                        .responsive-breadcrumb {
                            padding-top: 220px; /* Reduces height so it doesn't zoom in too much */
                            background-position: 70% center; /* Shifts focus to keep the people in frame */
                        }
                    }
                `}
            </style>
            
            <div className="breadcrumb__area responsive-breadcrumb inner-banner-container" style={{ 
                backgroundImage: `url(${bgImage || defaultBg})`
            }}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="breadcrumb__area-content">
                                <h2>{title}</h2>
                                <ul>
                                    <li><Link to="/">Home</Link><i className="fa-regular fa-angle-right"></i></li>
                                    <li>{innerTitle}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BreadCrumb;